<template>

  <DoubleColumnLayout>

    <v-container>

        <!-- Kalkules WP Top Banner -->
        <ConditionalAdsense
          data-ad-client="ca-pub-1338414232761221"
          data-ad-slot="3661147294"
          data-ad-format="auto"
          data-full-width-responsive="true"
        >
        </ConditionalAdsense>

      <h1>{{ $t('online.dateCalculator.metaTitle') }}</h1>
      <date-calculator :locale="$t('online.dateCalculator.locale')" :first-day-of-week="$t('online.dateCalculator.firstDayOfWeek')" />

    </v-container>

    <template v-slot:right>
      <AppList />
    </template>

  </DoubleColumnLayout>

</template>

<script>

import AppList from "@/components/AppList.vue";
import ConditionalAdsense from "@/components/ConditionalAdsense.vue";
import DateCalculator from "@/components/calculators/DateCalculator.vue";
import DoubleColumnLayout from "@/components/DoubleColumnLayout.vue";

export default {
  name: "DateCalculatorView",
  components: {
    AppList,
    ConditionalAdsense,
    DateCalculator,
    DoubleColumnLayout,
  },
  metaInfo() {
    return {
      title: this.$t('online.dateCalculator.metaTitle'),
      meta: [
        { property: "og:title", content: this.$t('online.dateCalculator.metaTitle') },
        { property: "og:description", content: this.$t('online.dateCalculator.metaDescription') },
        { name: "twitter:title", content: this.$t('online.dateCalculator.metaTitle') },
        { name: "twitter:description", content: this.$t('online.dateCalculator.metaDescription') },
        { itemprop: "name", content: this.$t('online.dateCalculator.metaTitle') },
        { itemprop: "description", content: this.$t('online.dateCalculator.metaDescription') },
      ],
    };
  },
};

</script>